import React from 'react'

import clsx from 'clsx'

import { BaseButton } from 'components/Button'

import classes from './CardActionArea.module.scss'

/** @type {import("./types").default} */
const CardActionArea = ({ children, className, ...props }) => {
  return (
    <BaseButton className={clsx('CardActionArea', classes.root, className)} {...props}>
      {children}
      <span className={clsx('focusHighlight', classes.focusHighlight)} />
    </BaseButton>
  )
}

export default CardActionArea
